import { createSelector } from 'reselect';
import { compose, filter, flatMap, get, reject, compact, uniq, map } from 'lodash/fp';
import { castIntegerIfPossible } from '@mews/framework';
import { notEmpty } from '@mews-commander/utils';
import { getServiceCategories, getSortedSpaces, getSpaces } from '../ducks/spaces';

export const getServiceResources = createSelector(getServiceCategories, getSpaces, (categories, resources) =>
    // @ts-expect-error $TSFixMeError: Property 'id' does not exist on type '{ serviceId: { toString: ...; charAt: ...; charCodeAt: ...; concat: ...; indexOf: ...
    flatMap(({ id }) => filter({ resourceCategoryId: id }, resources), categories)
);

// @ts-expect-error $TSFixMeError: No overload matches this call.
export const getResourcesWithoutCategory = createSelector(getSpaces, filter({ resourceCategoryId: null }));

export const getNonSlotServiceResources = createSelector(getServiceResources, reject('isSlot'));

export const getNonSlotSpaces = createSelector(getSortedSpaces, compose(reject('isSlot'), get('resources')));

export const sortFloors = (floors: $TSFixMe) =>
    floors.sort((a: $TSFixMe, b: $TSFixMe) => {
        const { aProp, bProp } = castIntegerIfPossible(a, b);

        if (aProp < bProp) {
            return -1;
        }
        return bProp < aProp ? 1 : 0;
    });

export const getUniqueResourceFloorNumbers = createSelector(
    getNonSlotSpaces,
    compose(sortFloors, compact, uniq, map('floorNumber'))
);

export const getUniqueServiceResourceFloorNumbers = createSelector(
    getServiceResources,
    compose(sortFloors, compact, uniq, map('floorNumber'), reject('isSlot'))
);

export const hasUniqueServiceResourceFloorNumbers = compose(notEmpty, getUniqueServiceResourceFloorNumbers);
